import Vue from 'vue'
import Vuex from 'vuex'
import Color from 'ac-colors';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authValid:true,
    Color,
    themeUpdated:false,
    currentColor:null,
    currentColorList:[],
    currentThemeName:"Untitled",
    currentThemeId:null,
    currentThemeColorList:[],
    colorToggleMode:"lchuv",
    colorToggleIncrement:{
        "rgb":[1,1,1],
        "hsl":[1,1,1],
        "xyz":[1,1,1],
        "lab":[1,1,1],
        "lchab":[1,1,1],
        "luv":[1,1,1],
        "lchuv":[1,1,1],
    },
    colorDisplayMode:"hex",
    colorDisplayModeList:[
         {
            "value":"rgb",
            "text":"RGB",
        },
        {
            "value":"hex",
            "text":"HEX",
        },
        {
            "value":"hsl",
            "text":"HSL",
        },
        {
            "value":"xyz",
            "text":"XYZ",
        },
        {
            "value":"lab",
            "text":"LAB",
        },
        {
            "value":'lchab',
            "text":"LCHab",
        },
        {
            "value":"luv",
            "text":"LUV",
        },
        {
            "value":'lchuv',
            "text":"LCHuv",
        },
    ],
    colorToggleConfig:{
        "rgb":{
            "name":"rgb",
            "title":"RGB",
            "headers":["Red","Green","Blue"],
            "min":[0,0,0],
            "max":[255,255,255]
        },
        "hsl":{
            "name":"hsl",
            "title":"HSL",
            "headers":["Hue","Saturation","Lightness"],
            "min":[0,0,0],
            "max":[360,100,100]
        },
        "xyz":{
            "name":"xyz",
            "title":"XYZ",
            "headers":["X","Y","Z"],
            "min":[0,0,0],
            "max":[96,100,109]
        },
        "lab":{
            "name":"lab",
            "title":"LAB",
            "headers":["L","A","B"],
            "min":[0,0,0],
            "max":[100,100,100]
        },
        "lchab":{
            "name":'lchab',
            "title":"LCHab",
            "headers":["Luminance","Chroma","Hue"],
            "min":[0,0,0],
            "max":[100,134,360]
        },
        "luv":{
            "name":"luv",
            "title":"LUV",
            "headers":["L","U","V"],
            "min":[0,0,0],
            "max":[100,100,100]
        },
        "lchuv":{
            "name":'lchuv',
            "title":"LCHuv",
            "headers":["Luminance","Chroma","Hue"],
            "min":[0,0,0],
            "max":[100,134,360]
        },
    }
  },
  mutations: {
    setCurrentColor(state,color){
        state.currentColor = color;
        state.currentColorList.unshift(color);
    },
    setToggleIncrement(state,payload){
        const cols = [...payload.cols]
        const mode = payload.mode;
        if(state.colorToggleIncrement[mode]){
            state.colorToggleIncrement[mode] = cols;
        }
    },
    setToggleTolerance(state,payload){
        let value = parseInt(payload.value);
        let col = parseInt(payload.col);
        let mode = payload.mode;
        if(state.colorToggleTolerance[mode][col]){
            let newColorToggleTolerance = [...state.colorToggleTolerance[mode]];
            newColorToggleTolerance[col] = value;
            state.colorToggleTolerance[mode] = newColorToggleTolerance;
        }
    },
    toggleCurrentThemeColor(state,color){
        let colorFound = false;
        for(let i=0;i<state.currentThemeColorList.length;i++){
            if(state.currentThemeColorList[i].hexString == color.hexString){
                colorFound = true;
                state.currentThemeColorList.splice(i,1);
            }
        }
        if(!colorFound){
            state.currentThemeColorList.unshift(color);
        }
        state.themeUpdated = false;
    },
    setThemeName(state,name){
        if(name.length>0){
            state.currentThemeName = name;
        }else{
            state.currentThemeName="Untitled";
        }
        state.themeUpdated = false;
    },
    setThemeColors(state,colors){
        state.currentThemeColorList = colors;
    },
    setAuthValid(state,val){
        state.authValid = val;
    },
    setThemeUpdated(state,val){
        state.themeUpdated = val;
    },
    setThemeId(state,val){
        state.currentThemeId = val;
    },
},
  modules: {
  }
})
